export const endpoints = {
    HOME: '/home/view',
    TASKS_UPDATE: "/task/update",
  }